import React, { useState, useEffect, useContext } from 'react'
import FindAndReplaceFooter from './FindAndReplaceFooter'
import FindAndReplaceHeader from './FindAndReplaceHeader'
import FindAndReplaceInner from './FindAndReplaceInner'
import FindAndReplaceControllerStyle from './css/FindAndReplaceControllerStyle'
import { appContext } from '../../App'
import { getProductsList, findAndReplaceItem } from '../products/ProductsFunctions'

export const findAndReplaceContext = React.createContext()

function useFindAndReplace () {
  const app = useContext(appContext)
  const [productsList, setProductsList] = useState([])
  const [item, setItem] = useState({
    brand_from: '', brand_to: '', brand_message: '',
    name_from: '', name_to: '', name_message: '',
    description_from: '', description_to: '', description_message: '',
    classification_from: '', classification_to: '' , classification_message: ''
  })

  const findAndReplaceItems = async () => {
    const fields = ['brand', 'name', 'description', 'classification']
    // for() is necessary and the right choice than for.each() since we have a promised function
    for (let field of fields) {
      const from_to = { from: item[field+'_from'], to: item[field+'_to'] }
      const result = await findAndReplaceItem(app, field, from_to)
      item[field+'_message'] = `${result} rows updated!`
    }
    setItem({...item})
  }

  useEffect(() => {
    (async () => { setProductsList(await getProductsList(app)) })()
    /* Hack to avoid the eslint warning */
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return ({
    products_list: productsList,
    item: [item, setItem],
    findAndReplaceItems,
    getProductsList,
  })
}

function FindAndReplaceController() {
  const findAndReplace = useFindAndReplace()
  return (
    <React.Fragment>
      <findAndReplaceContext.Provider value={findAndReplace}>
        <FindAndReplaceHeader />
        <FindAndReplaceInner />
        <FindAndReplaceFooter />
        <FindAndReplaceControllerStyle />
      </findAndReplaceContext.Provider>
    </React.Fragment>
  )
}

export default React.memo(FindAndReplaceController)